"use client";

import React from "react";
import { Building2, Flame, FlaskConical, Ship } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const industries = [{
  id: "energy",
  title: "Energia — Óleo & Gás",
  icon: Flame,
  bgClass: "bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1608045/img/industry_energy_bg.png)]"
}, {
  id: "maritime",
  title: "Marítimo",
  icon: Ship,
  bgClass: "bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1608045/img/industry_maritime_bg.png)]"
}, {
  id: "chemicals",
  title: "Químicos",
  icon: FlaskConical,
  bgClass: "bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1608045/img/industry_chemicals_bg.png)]"
}, {
  id: "infrastructure",
  title: "Infraestrutura",
  icon: Building2,
  bgClass: "bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1608045/img/industry_infrastructure_bg.png)]"
}];
export default function IndustryApplications() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="setores" className="py-32 bg-background">
      <div className="container mx-auto px-4 md:px-6 max-w-[1440px]">
        <div ref={ref} className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <div className="text-center mb-16">
            <span className="text-primary font-bold tracking-wider uppercase text-sm mb-4 block">
              Setores Atendidos
            </span>
            <h2 className="font-default text-4xl md:text-5xl font-bold text-foreground">
              Soluções para os Ambientes Industriais Mais Desafiadores
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6">
            {industries.map((item, i) => <div key={item.id} data-index={i} className="group relative h-[400px] md:h-[500px] rounded-xl overflow-hidden bg-card cursor-default">
                {}
                <div className={`absolute inset-0 bg-cover bg-center grayscale-[50%] transition-transform duration-700 ease-out group-hover:scale-105 ${item.bgClass}`} />

                {}
                <div className="absolute inset-0 bg-black/40 transition-colors duration-500 group-hover:bg-black/50" />

                {}
                <div className="absolute inset-0 z-10 pointer-events-none overflow-hidden">
                  <div className="absolute top-0 bottom-0 left-0 w-[150%] bg-gradient-to-r from-transparent via-primary/30 to-transparent -translate-x-[150%] skew-x-[-20deg] transition-transform duration-[1200ms] ease-in-out group-hover:translate-x-[100%]" />
                </div>

                {}
                <div className="relative z-20 h-full flex flex-col items-center justify-center p-8 text-center">
                  <item.icon className="size-12 text-primary mb-6 transition-transform duration-500 ease-out group-hover:scale-110 group-hover:-translate-y-2" />
                  <h3 className="font-default text-3xl font-bold text-white tracking-tight drop-shadow-md">
                    {item.title}
                  </h3>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}